/* eslint-disable no-console */
export default sub => (error) => {
  if (!error) return;
  let errData;
  if (error.response && error.response.data) {
    errData = error.response.data;
  }
  if (error.data) {
    errData = error.data;
  }
  if (!errData) {
    console.error(error);
    return;
  }
  if (errData.code && sub && sub(errData.code)) return;
  alert(errData.message || errData);
};



// WEBPACK FOOTER //
// ./src/util/ErrorHandler.js